<template>
  <div class="payment-card-banner mobile-banner">
    <div class="banner-logo">
      <div class="logo-wrap">
        <img src="@/assets/images/nic-asia-bank.png" alt="" v-if="customerData.merchantDetail.merchantLogo === ''" />
        <img v-else :src="customerData.merchantDetail.merchantLogo"/>
      </div>
    </div>
    <div class="banner-text">
      <h1 class="payment-heading">
        {{ customerData.merchantDetail.companyName }}
      </h1>
      <span class="sub-title"
        >{{ customerData.merchantDetail.contactNumber }}</span
      >
      <h2 class="payment-amount">
        {{ formatCurrency(customerData) }}
      </h2>
    </div>
  </div>
</template>
<script>
import { formatCurrency } from '../../../lib/currency'
export default {
  name: "MobileHeader",
  props: {
    customerData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    formatCurrency
  }
};
</script>
